"use strict";
/*
* Created on 26.04.2019
*/

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var StateDomainObject_1 = require("../../core/model/StateDomainObject");
/**
 * Domain object class for order suggested headers repository
 * @author ZSr
 */


var SupplierOrderSuggestedHeader =
/*#__PURE__*/
function (_StateDomainObject_1$) {
  _inherits(SupplierOrderSuggestedHeader, _StateDomainObject_1$);

  /**
   * @param id the internal id
   * @param externalId - orderSuggestedAholdId
   * @param siteId
   * @param supplierId
   * @param dateOfOrder
   * @param promotionId - internal promotionExternalId
   * @param stateFlags
   */
  function SupplierOrderSuggestedHeader(id, externalId, siteId, supplierId, dateOfOrder, promotionId, stateFlags) {
    var _this;

    _classCallCheck(this, SupplierOrderSuggestedHeader);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SupplierOrderSuggestedHeader).call(this, stateFlags));
    _this.id = id;
    _this.externalId = externalId;
    _this.siteId = siteId;
    _this.supplierId = supplierId;
    _this.dateOfOrder = dateOfOrder;
    _this.promotionId = promotionId;
    _this.stateFlags = stateFlags;
    return _this;
  }

  return SupplierOrderSuggestedHeader;
}(StateDomainObject_1.StateDomainObject);

exports.SupplierOrderSuggestedHeader = SupplierOrderSuggestedHeader;

SupplierOrderSuggestedHeader.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SupplierOrderSuggestedHeader.name);
  return {
    id: builder.id('id'),
    externalId: builder.str('externalId'),
    siteId: builder.str('siteId'),
    supplierId: builder.str('supplierId'),
    dateOfOrder: builder.date('dateOfOrder', DateParser_1.DateParser.ISO_PATTERN),
    promotionId: builder.opt(builder.str('promotionId')),
    stateFlags: builder.flags('stateFlags', EntityStateFlag_1.EntityStateFlag)
  };
}();